import { render, staticRenderFns } from "./freightCost.vue?vue&type=template&id=097380fd&scoped=true&"
import script from "./freightCost.vue?vue&type=script&lang=js&"
export * from "./freightCost.vue?vue&type=script&lang=js&"
import style0 from "./freightCost.vue?vue&type=style&index=0&id=097380fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097380fd",
  null
  
)

export default component.exports